<template>
  <div v-html="vars.titleHtml" class="tw-flex tw-justify-center tw-z-50" />

  <section class="tw-h-[80vh] relative">

    <video
      ref="bgVideo"
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      playsinline
      @click="togglePlay"
    ></video>

    <video
      ref="bgVideo"
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
      playsinline
      @click="togglePlay"
    ></video>

    <div
      v-if="!isPlaying"
      @click="togglePlay"
      class="absolute inset-0 flex items-center justify-center cursor-pointer z-50"
    >
      <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="70" cy="70" r="70" fill="white"/>
        <path d="M78.7631 70.5L65.6031 78.732L64.2031 79.6V61.4L78.7631 70.5ZM76.1031 70.5L65.6031 63.92V77.08L76.1031 70.5Z" fill="#EF787C"/>
      </svg>
    </div>
  </section>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'SingleVideo',
  mixins: [ComponentMixin],
  
  data() {
    return {
      isPlaying: false as boolean
    };
  },
  
  methods: {
    togglePlay() {
      const vid = this.$refs.bgVideo as HTMLVideoElement | undefined;
      if (!vid) return;

      if (vid.paused) {
        vid.play();
        this.isPlaying = true;
      } else {
        vid.pause();
        this.isPlaying = false;
      }
    },
  },
});
</script>

